export default __webpack_public_path__ + "static/media/94_mobile.d91595ba.jpg";